module.exports = __webpack_public_path__ + "img/485a3a0c2fe40dde16ae6d42f0abef16.png";